export default __webpack_public_path__ + "static/media/Image-4.bac0f010.jpg";